import { InjectionToken } from '@angular/core';

export interface IPersonalDataProtectionStorage {
    set<T>(key: string, value: T);
    get<T>(key: string, defaultValue?: T | null): T | null | Promise<T> | Promise<null>;
}

export const PERSONAL_DATA_PROTECTION_STORAGE = new InjectionToken<IPersonalDataProtectionStorage>(
    'IPersonalDataProtectionStorage'
);
